import { render, staticRenderFns } from "./NewCreateAulaInfantil.vue?vue&type=template&id=fb25d47a&scoped=true"
import script from "./NewCreateAulaInfantil.vue?vue&type=script&lang=js"
export * from "./NewCreateAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./NewCreateAulaInfantil.vue?vue&type=style&index=0&id=fb25d47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb25d47a",
  null
  
)

export default component.exports